/* v8 ignore start */
import { CustomEventEmitter } from '@/util/event';

import type { BaseApiResponse } from '../axios/type';

type ApiErrorEvent = BaseApiResponse;

type ApiErrorEventMap = {
  error: any;
};

export const apiErrorEventManager = new CustomEventEmitter<ApiErrorEventMap>();

export const emitApiError = (errorData: ApiErrorEvent) => {
  apiErrorEventManager.emit('error', errorData);
};

export const onApiError = (
  callback: (event: ApiErrorEventMap['error']) => void,
) => {
  apiErrorEventManager.on('error', callback);

  return () => {
    apiErrorEventManager.off('error', callback);
  };
};
/* v8 ignore end */
